import React, { useEffect, useRef, useState } from 'react';
import {
    ContainerWineChild,
    ContainerWineChildForModal,
    ContainerWineImage,
    ContainerWineImageForModal,
    WinePerimeterImage,
    WineImage,
    WineImageForForm,
    FlagImage,
    ContainerWineText,
    ContainerWineTextForForm,
    ContainerWineTextChildForNameAndFlag,
    ContainerWineTextChildForNameAndFlagForForm,
    ContainerWineTextChild,
    ContainerCircleForElementTheWine,
    CircleForElementTheWine,
    ContainerWineChildTextTheWineAndName,
    ContainerWineChildTextTheWineAndNameForForm,
    ContainerWineChildTextTheWine,
    WineParameterNameBold,
    WineTitle,
    ContainerButtomForViewMoreAndLess,
    ContainerFormObjectChildButton,
    ModalHeader,
    ModalHeaderText,
    ModalContent,
    CloseModalButtom
} from '../../js/Styles'; // Ajusta la ruta según tu estructura
import backgroundFood from '../../../assets/images/backgroundFood.png';

import Modal from 'react-modal'; // Importa react-modal

const customStyles = {
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 1000,
    },
    content: {
        top: '10px',
        left: '10px',
        right: '10px',
        bottom: '10px',
        padding: '0px',
        fontFamily: '"Monserrat", sans-serif',
        overflow: 'none'
    },
};

function Wine({wine}) {

    const [isModalOpen, setIsModalOpen] = useState(false); // Estado para mostrar/ocultar el modal
    const [show_more_or_less, setShowMoreOrLess] = useState(false); // Estado para mostrar menos o más parametros del vino
    
    // Manejador de eventos cuando se selecciona un vino
    const handleSelectWine = (event) => {
        setIsModalOpen(true);
    };
    

    // Manejador para cerrar el modal
    const closeModal = () => {
        setIsModalOpen(false);
    };
    
    return (
        <>
            <ContainerWineChild>
                <ContainerWineImage onClick={()=> handleSelectWine()}>
                    <WinePerimeterImage src={backgroundFood}/>
                    <WineImage src={wine.imagen} />
                </ContainerWineImage>
                <ContainerWineText style={{borderBottom: "2px solid white"}}>
                    <ContainerWineTextChildForNameAndFlag>
                        <ContainerWineChildTextTheWineAndName>

                            <WineParameterNameBold><WineTitle style={{color: "white"}}>{wine.nombre}</WineTitle></WineParameterNameBold>
                            <ContainerCircleForElementTheWine>
                                <FlagImage src={wine.imagen_bandera_pais} />
                            </ContainerCircleForElementTheWine>
                        </ContainerWineChildTextTheWineAndName>
                    </ContainerWineTextChildForNameAndFlag>

                    <ContainerButtomForViewMoreAndLess>
                        <ContainerFormObjectChildButton onClick={() => handleSelectWine()}>Ver más</ContainerFormObjectChildButton>
                    </ContainerButtomForViewMoreAndLess>
                </ContainerWineText>
            </ContainerWineChild>
            <Modal
                style={customStyles}
                isOpen={isModalOpen}
                onRequestClose={closeModal}
                ariaHideApp={false} 
            >
                {isModalOpen && (
                    <ModalContent>
                        {/* Agrega más detalles del evento aquí */}
                        <ModalHeader>
                            <ModalHeaderText>{wine.tipo}</ModalHeaderText>
                            <CloseModalButtom onClick={closeModal}>X</CloseModalButtom>
                        </ModalHeader>
                        <ContainerWineChildForModal>
                            <ContainerWineImageForModal>
                                
                                <WineImageForForm src={wine.imagen} />
                            </ContainerWineImageForModal>
                            <ContainerWineTextForForm>
                                <ContainerWineTextChildForNameAndFlagForForm>
                                    <ContainerWineChildTextTheWineAndNameForForm>

                                        <WineParameterNameBold><WineTitle>{wine.nombre}</WineTitle></WineParameterNameBold>
                                        <ContainerCircleForElementTheWine>
                                            <FlagImage src={wine.imagen_bandera_pais} />
                                        </ContainerCircleForElementTheWine>
                                    </ContainerWineChildTextTheWineAndNameForForm>
                                </ContainerWineTextChildForNameAndFlagForForm>
                                <ContainerWineTextChild>

                                    <ContainerWineChildTextTheWine>
                                        <ContainerCircleForElementTheWine>
                                            <CircleForElementTheWine />
                                        </ContainerCircleForElementTheWine>
                                        
                                        <WineParameterNameBold>Variedad: <WineTitle>{wine.variedad}</WineTitle></WineParameterNameBold>
                                    </ContainerWineChildTextTheWine>

                                    <ContainerWineChildTextTheWine>
                                        <ContainerCircleForElementTheWine>
                                            <CircleForElementTheWine />
                                        </ContainerCircleForElementTheWine>
                                        
                                        <WineParameterNameBold>Origen: <WineTitle>{wine.origen_variedad}</WineTitle></WineParameterNameBold>
                                    </ContainerWineChildTextTheWine>

                                    <ContainerWineChildTextTheWine>
                                        <ContainerCircleForElementTheWine>
                                            <CircleForElementTheWine />
                                        </ContainerCircleForElementTheWine>
                                        
                                        <WineParameterNameBold>Crianza: <WineTitle>{wine.crianza}</WineTitle></WineParameterNameBold>
                                    </ContainerWineChildTextTheWine>

                                    <ContainerWineChildTextTheWine>
                                        <ContainerCircleForElementTheWine>
                                            <CircleForElementTheWine />
                                        </ContainerCircleForElementTheWine>
                                        
                                        <WineParameterNameBold>Temperatura de servicio: <WineTitle>{wine.temperatura_servicio}</WineTitle></WineParameterNameBold>
                                    </ContainerWineChildTextTheWine>

                                    <ContainerWineChildTextTheWine>
                                        <ContainerCircleForElementTheWine>
                                            <CircleForElementTheWine />
                                        </ContainerCircleForElementTheWine>
                                        
                                        <WineParameterNameBold>Graducación alcohólica: <WineTitle>{wine.graducacion_alcoholica}</WineTitle></WineParameterNameBold>
                                    </ContainerWineChildTextTheWine>

                                    <ContainerWineChildTextTheWine>
                                        <ContainerCircleForElementTheWine>
                                            <CircleForElementTheWine />
                                        </ContainerCircleForElementTheWine>
                                        
                                        <WineParameterNameBold>Vista: <WineTitle>{wine.vista}</WineTitle></WineParameterNameBold>
                                    </ContainerWineChildTextTheWine>

                                    <ContainerWineChildTextTheWine>
                                        <ContainerCircleForElementTheWine>
                                            <CircleForElementTheWine />
                                        </ContainerCircleForElementTheWine>
                                        
                                        <WineParameterNameBold>Nariz: <WineTitle>{wine.nariz}</WineTitle></WineParameterNameBold>
                                    </ContainerWineChildTextTheWine>

                                    <ContainerWineChildTextTheWine>
                                        <ContainerCircleForElementTheWine>
                                            <CircleForElementTheWine />
                                        </ContainerCircleForElementTheWine>
                                        
                                        <WineParameterNameBold>Boca: <WineTitle>{wine.boca}</WineTitle></WineParameterNameBold>
                                    </ContainerWineChildTextTheWine>

                                    <ContainerWineChildTextTheWine>
                                        <ContainerCircleForElementTheWine>
                                            <CircleForElementTheWine />
                                        </ContainerCircleForElementTheWine>
                                        
                                        <WineParameterNameBold>Maridaje: <WineTitle>{wine.maridaje}</WineTitle></WineParameterNameBold>
                                    </ContainerWineChildTextTheWine>

                                    {
                                        wine.precio_bot > 0 ?
                                        <ContainerWineChildTextTheWine>
                                            <ContainerCircleForElementTheWine>
                                                <CircleForElementTheWine />
                                            </ContainerCircleForElementTheWine>
                                            
                                            <WineParameterNameBold>Precio botella: <WineTitle>${wine.precio_bot}</WineTitle></WineParameterNameBold>
                                        </ContainerWineChildTextTheWine> : <></>
                                    }
                                    {
                                        wine.precio > 0 ?
                                        <ContainerWineChildTextTheWine>
                                            <ContainerCircleForElementTheWine>
                                                <CircleForElementTheWine />
                                            </ContainerCircleForElementTheWine>
                                            
                                            <WineParameterNameBold>Precio copa: <WineTitle>${wine.precio}</WineTitle></WineParameterNameBold>
                                        </ContainerWineChildTextTheWine> : <></>
                                    }
                                    <br/>
                                    <br/>
                                </ContainerWineTextChild>
                            </ContainerWineTextForForm>
                        </ContainerWineChildForModal>
                    </ModalContent>
                )}
            </Modal>
        </>
    )
}

export default Wine